import useRequest from '@/websdk/utils/request';
export default function (params) {

  const { isRequestSuccessed, data, exec } = useRequest({
    url: '/api/energeoverview?factory_id=""',
    name: 'GET_MACHINE',
  });
  return [isRequestSuccessed, data || {}, exec];
}
